import { defaultApiState } from '../api.state';

export const advisorMutations = {
  GET_ADVISORS_LOADING(state) {
    state.apiState.getAdvisors = {
      ...defaultApiState,
      loading: true,
    };
  },
  GET_ADVISORS_SUCCESS(state, payload) {
    state.apiState.getAdvisors = {
      ...defaultApiState,
      success: true,
    };
    state.advisors = payload;
  },
  GET_ADVISORS_ERROR(state, error) {
    state.apiState.getAdvisors = {
      ...defaultApiState,
      error,
    };
  },

  ADD_ADVISOR_LOADING(state) {
    state.apiState.addAdvisor = {
      ...defaultApiState,
      loading: true,
    };
  },
  ADD_ADVISOR_SUCCESS(state) {
    state.apiState.addAdvisor = {
      ...defaultApiState,
      success: true,
    };
  },
  ADD_ADVISOR_ERROR(state, error) {
    state.apiState.addAdvisor = {
      ...defaultApiState,
      error,
    };
  },

  GET_ADVISOR_RESET(state) {
    state.apiState.getAdvisor = {
      ...defaultApiState,
    };
    state.advisor = undefined;
  },

  GET_ADVISOR_LOADING(state) {
    state.apiState.getAdvisor = {
      ...defaultApiState,
      loading: true,
    };
  },
  GET_ADVISOR_SUCCESS(state, payload) {
    state.apiState.getAdvisor = {
      ...defaultApiState,
      success: true,
    };
    state.advisor = payload;
  },
  GET_ADVISOR_ERROR(state, error) {
    state.apiState.getAdvisor = {
      ...defaultApiState,
      error,
    };
  },

  UPDATE_ADVISOR_LOADING(state) {
    state.apiState.updateAdvisor = {
      ...defaultApiState,
      loading: true,
    };
  },
  UPDATE_ADVISOR_SUCCESS(state) {
    state.apiState.updateAdvisor = {
      ...defaultApiState,
      success: true,
    };
  },
  UPDATE_ADVISOR_ERROR(state, error) {
    state.apiState.updateAdvisor = {
      ...defaultApiState,
      error,
    };
  },

  DELETE_ADVISOR_LOADING(state) {
    state.apiState.deleteAdvisor = {
      ...defaultApiState,
      loading: true,
    };
  },
  DELETE_ADVISOR_SUCCESS(state, payload) {
    state.apiState.deleteAdvisor = {
      ...defaultApiState,
      success: true,
    };
    state.advisors = state.advisors.filter(o => o.id !== payload.id);
  },
  DELETE_ADVISOR_ERROR(state, error) {
    state.apiState.deleteAdvisor = {
      ...defaultApiState,
      error,
    };
  },

  GET_ADVISOR_APPOINTMENT_CONFIG_LOADING(state) {
    state.apiState.getAdvisorAppointmentConfig = {
      ...defaultApiState,
      loading: true,
    };
  },
  GET_ADVISOR_APPOINTMENT_CONFIG_SUCCESS(state, payload) {
    state.apiState.getAdvisorAppointmentConfig = {
      ...defaultApiState,
      success: true,
    };
    state.advisorAppointmentConfig = payload;
  },
  GET_ADVISOR_APPOINTMENT_CONFIG_ERROR(state, error) {
    state.apiState.getAdvisorAppointmentConfig = {
      ...defaultApiState,
      error,
    };
  },

  UPDATE_ADVISOR_APPOINTMENT_CONFIG_LOADING(state) {
    state.apiState.updateAdvisorAppointmentConfig = {
      ...defaultApiState,
      loading: true,
    };
  },
  UPDATE_ADVISOR_APPOINTMENT_CONFIG_SUCCESS(state) {
    state.apiState.updateAdvisorAppointmentConfig = {
      ...defaultApiState,
      success: true,
    };
  },
  UPDATE_ADVISOR_APPOINTMENT_CONFIG_ERROR(state, error) {
    state.apiState.updateAdvisorAppointmentConfig = {
      ...defaultApiState,
      error,
    };
  },
};
